interface AudioQualityDisplayProps {
  quality: { sampleRate: number | null; sampleSize: number | null } | null;
}

export function AudioQualityDisplay({ quality }: AudioQualityDisplayProps) {
  const label = quality
    ? [
        quality.sampleSize ? `${quality.sampleSize}-bit` : null,
        quality.sampleRate ? `${quality.sampleRate / 1000}kHz` : null,
      ]
        .filter(Boolean)
        .join(" / ") || "—"
    : "—";

  return <p className="text-white text-sm mt-[5px]">{label}</p>;
}
